export default "__VITE_ASSET__007a5c97__"